import { render, staticRenderFns } from "./payorDetailSelector.vue?vue&type=template&id=672c5a5e&scoped=true&"
import script from "./payorDetailSelector.vue?vue&type=script&lang=js&"
export * from "./payorDetailSelector.vue?vue&type=script&lang=js&"
import style0 from "./payorDetailSelector.vue?vue&type=style&index=0&id=672c5a5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c5a5e",
  null
  
)

export default component.exports